var rules = {
  first_name: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Voornaam',
      name: 'first_name',
      placeholder: '',
      validationRules: 'required|min:2',
      autocomplete: 'given-name',
      type: 'text'
    }
  },
  last_name: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Achternaam',
      placeholder: '',
      validationRules: 'required|min:2',
      name: 'last_name',
      autocomplete: 'family-name',
      type: 'text'
    }
  },
  full_name: {
    name: 'Voor- en achternaam',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Voor- en achternaam',
      placeholder: '',
      validationRules: {
        required: true,
        regex: /^\s*\S{2,}\s+\S{2}.*$/
      },
      name: 'full_name',
      autocomplete: 'name',
      type: 'text'
    }
  },
  birthdate: {
    name: 'Geboortedatum',
    type: 'date',
    mongo_type: Date,
    form: {
      info: '',
      component: 'DateInput',
      label: 'Geboortedatum',
      name: 'birthdate',
      autocomplete: 'bday',
    }
  },
  date_max_today: {
    name: 'Datum',
    type: 'date',
    mongo_type: Date,
    form: {
      info: '',
      component: 'DateInput',
      label: 'Datum',
      name: 'date',
    }
  },
  gender: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Civilite',
      name: 'gender',
      type: 'radio',
      label: 'Geslacht'
    }
  },
  phone: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Telefoonnummer',
      placeholder: '',
      name: 'phone',
      validationRules: {
        required: true,
        phone: {
          phoneType: 'both',
          defaultCountry: 'NL',
          acceptedCountries: ['BE','FR','LU','NL']
        }
      },
      autocomplete: 'tel',
      inputmode: 'tel',
      type: 'tel'
    },
  },
  fixed_phone: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Vast telefoonnummer',
      placeholder: '',
      name: 'fixed_phone',
      validationRules: {
        required: true,
        phone: {
          phoneType: 'fixed',
          defaultCountry: 'NL',
          acceptedCountries: ['NL']
        }
      },
      autocomplete: 'tel',
      inputmode: 'tel',
      type: 'tel'
    }
  },
  mobile_phone: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Mobiele telefoonnummer',
      placeholder: '',
      name: 'mobile_phone',
      validationRules: {
        required: true,
        phone: {
          phoneType: 'mobile',
          defaultCountry: 'NL',
          acceptedCountries: ['NL']
        }
      },
      autocomplete: 'tel',
      inputmode: 'tel',
      type: 'tel'
    }
  },
  email: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'E-mail',
      placeholder: '',
      confirmation_label: 'Bevestig je email',
      validationRules: 'required|email',
      name: 'email',
      confirmation: true,
      autocomplete: 'email',
      inputmode: 'email',
      type: 'email'
    }
  },
  rib: {
    type: 'file',
    mongo_type: String,
    form: {
      info: '',
      component: 'File',
      label: 'Bankrib',
      size: 50000,
      name: 'rib',
      accept: '.pdf,image/*'
    }
  },
  bar_code: {
    name: 'Product streepjescode',
    type: 'file',
    mongo_type: String,
    form: {
      info: '',
      component: 'File',
      label: 'Product streepjescode',
      size: 50000,
      name: 'bar_code',
      accept: '.pdf,image/*'
    }
  },
  receipt: {
    type: 'file',
    mongo_type: String,
    form: {
      info: '',
      component: 'File',
      label: 'Betalingsbewijs',
      size: 50000,
      name: 'receipt',
      accept: '.pdf,image/*'
    }
  },
  id_proof: {
    type: 'file',
    mongo_type: String,
    form: {
      info: '',
      component: 'File',
      size: 50000,
      label: 'Identiteitsbewijs',
      name: 'id_proof',
      accept: '.pdf,image/*'
    }
  },
  address: {
    name: 'Postadres',
    type: 'string',
    mongo_type: String,
    recursive: {
      address: true,
      postcode: true,
      city: true,
      complement: false
    },
    form: {
      info: '',
      component: 'Adresse',
      name: 'address',
      country: 'nl',
      validationRules: 'required|min:2',
      label: 'Adres',
      cannotFindMessage: 'Staat uw adres er niet bij?'
    }
  },
  city: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Stad',
      placeholder: '',
      name: 'city',
      type: 'text'
    }
  },
  postal_code: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Postcode',
      placeholder: '',
      name: 'postcode',
      validationRules: 'required|digits:5',
      type: 'text'
    }
  },
  country: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Land',
      name: 'country',
      type: 'text'
    }
  },
  buying_date: {
    type: 'date',
    mongo_type: Date,
    form: {
      info: '',
      component: 'DateInput',
      label: 'Aankoopdatum',
      name: 'buying_date'
    }
  },
  date_input: {
    name: 'Datum',
    type: 'date',
    mongo_type: Date,
    form: {
      info: '',
      component: 'DateInput',
      label: 'Datum',
      name: 'date'
    }
  },
  iban: {
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Iban',
      label: 'IBAN',
      placeholder: '',
      name: 'iban'
    }
  },
  confirmation: {
    type: 'boolean',
    mongo_type: Boolean,
    form: {
      info: '',
      component: 'Input',
      type: 'checkbox',
      name: 'confirm',
      label: 'Ik heb de spelregels gelezen en ga ermee akkoord.'
    }
  },
  marketing_opt_in_1: {
    name: 'Inscription marketing 1',
    type: 'boolean',
    mongo_type: Boolean,
    form: {
      info: '',
      component: 'Input',
      type: 'checkbox',
      name: 'marketing1',
      required: false
    }
  },
  marketing_opt_in_2: {
    name: 'Inscription marketing 2',
    type: 'boolean',
    mongo_type: Boolean,
    form: {
      info: '',
      component: 'Input',
      type: 'checkbox',
      name: 'marketing2',
      required: false
    }
  },
  // date_picker: {     type: 'string',
  // mongo_type: String, form: {},
  dropdown: {
    name: 'Menu déroulant',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'exemple',
      name: 'select',
      default_option_text: 'défaut',
      options: [{ name: 'Test 1', value: '1' }, 'test2']
    }
  },
  lieu_achat_dropdown: {
    name: 'Aankoopplaats',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Aankoopplaats',
      name: 'lieu achat',
      default_option_text: 'défaut',
      options: [{ name: 'Sur Internet', value: 'Internet' }, { name: 'En magasin', value: 'Magasin' }]
    }
  },
  enseigne: {
    name: 'Winkel Bord',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Winkel Bord',
      name: 'enseigne',
      default_option_text: 'défaut',
      options: [{value: "Amazon", name: "Amazon"}, {value: "Autre", name: "Autre"}]
    }
  },
  produit_achete: {
    name: 'Gekocht product',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Gekocht product',
      name: 'produit acheté',
      default_option_text: 'défaut',
      options: [{value: "exemple1", name: "exemple1"}, {value: "exemple2", name: "exemple2"}]
    }
  },
  produits_achetes: {
    name: 'Gekochte producten',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'MultiSelect',
      label: 'Gekochte producten',
      name: 'Gekochte producten',
      default_option_text: 'défaut',
      options: [{value: "exemple1", name: "exemple1"}, {value: "exemple2", name: "exemple2"}]
    }
  },
  MultiSelect: {
    name: 'select multiple',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'MultiSelect',
      label: 'select multiple',
      name: 'select multiple',
      default_option_text: 'défaut',
      options: [{value: "exemple1", name: "exemple1"}, {value: "exemple2", name: "exemple2"}]
    }
  },
  howknow: {
    name: 'Hoe heb je over de operatie gehoord?',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Hoe heb je over de operatie gehoord?',
      name: 'connu comment',
      default_option_text: 'défaut',
      options: [
        {name: "Sur internet", value: "Sur Internet"},
        {name: "En magasin", value: "En Magasin"},
        {name: "Pub TV", value: "Pub TV"},
        {name: "Bouche à oreilles", value: "Bouche à oreilles"}
      ]
    }
  },
  departement: {
    name: 'Afdeling',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Select',
      label: 'Afdeling',
      name: 'département',
      default_option_text: 'défaut',
      options: [
        {value: "01", name: "01 - Ain"},
        {value: "02", name: "02 - Aisne"},
        {value: "03", name: "03 - Allier"},
        {value: "04", name: "04 - Alpes-de-Haute-Provence"},
        {value: "05", name: "05 - Hautes-Alpes"},
        {value: "06", name: "06 - Alpes-Maritimes"},
        {value: "07", name: "07 - Ardèche"},
        {value: "08", name: "08 - Ardennes"},
        {value: "09", name: "09 - Ariège"},
        {value: "10", name: "10 - Aube"},
        {value: "11", name: "11 - Aude"},
        {value: "12", name: "12 - Aveyron"},
        {value: "13", name: "13 - Bouches-du-Rhône"},
        {value: "14", name: "14 - Calvados"},
        {value: "15", name: "15 - Cantal"},
        {value: "16", name: "16 - Charente"},
        {value: "17", name: "17 - Charente-Maritime"},
        {value: "18", name: "18 - Cher"},
        {value: "19", name: "19 - Corrèze"},
        {value: "2A", name: "2A - Corse du sud"},
        {value: "2B", name: "2B - Corse du nord"},
        {value: "21", name: "21 - Côte-d'or"},
        {value: "22", name: "22 - Côtes-d'armor"},
        {value: "23", name: "23 - Creuse"},
        {value: "24", name: "24 - Dordogne"},
        {value: "25", name: "25 - Doubs"},
        {value: "26", name: "26 - Drôme"},
        {value: "27", name: "27 - Eure"},
        {value: "28", name: "28 - Eure-et-Loir"},
        {value: "29", name: "29 - Finistère"},
        {value: "30", name: "30 - Gard"},
        {value: "31", name: "31 - Haute-Garonne"},
        {value: "32", name: "32 - Gers"},
        {value: "33", name: "33 - Gironde"},
        {value: "34", name: "34 - Hérault"},
        {value: "35", name: "35 - Ille-et-Vilaine"},
        {value: "36", name: "36 - Indre"},
        {value: "37", name: "37 - Indre-et-Loire"},
        {value: "38", name: "38 - Isère"},
        {value: "39", name: "39 - Jura"},
        {value: "40", name: "40 - Landes"},
        {value: "41", name: "41 - Loir-et-Cher"},
        {value: "42", name: "42 - Loire"},
        {value: "43", name: "43 - Haute-Loire"},
        {value: "44", name: "44 - Loire-Atlantique"},
        {value: "45", name: "45 - Loiret"},
        {value: "46", name: "46 - Lot"},
        {value: "47", name: "47 - Lot-et-Garonne"},
        {value: "48", name: "48 - Lozère"},
        {value: "49", name: "49 - Maine-et-Loire"},
        {value: "50", name: "50 - Manche"},
        {value: "51", name: "51 - Marne"},
        {value: "52", name: "52 - Haute-Marne"},
        {value: "53", name: "53 - Mayenne"},
        {value: "54", name: "54 - Meurthe-et-Moselle"},
        {value: "55", name: "55 - Meuse"},
        {value: "56", name: "56 - Morbihan"},
        {value: "57", name: "57 - Moselle"},
        {value: "58", name: "58 - Nièvre"},
        {value: "59", name: "59 - Nord"},
        {value: "60", name: "60 - Oise"},
        {value: "61", name: "61 - Orne"},
        {value: "62", name: "62 - Pas-de-Calais"},
        {value: "63", name: "63 - Puy-de-Dôme"},
        {value: "64", name: "64 - Pyrénées-Atlantiques"},
        {value: "65", name: "65 - Hautes-Pyrénées"},
        {value: "66", name: "66 - Pyrénées-Orientales"},
        {value: "67", name: "67 - Bas-Rhin"},
        {value: "68", name: "68 - Haut-Rhin"},
        {value: "69", name: "69 - Rhône"},
        {value: "70", name: "70 - Haute-Saône"},
        {value: "71", name: "71 - Saône-et-Loire"},
        {value: "72", name: "72 - Sarthe"},
        {value: "73", name: "73 - Savoie"},
        {value: "74", name: "74 - Haute-Savoie"},
        {value: "75", name: "75 - Paris"},
        {value: "76", name: "76 - Seine-Maritime"},
        {value: "77", name: "77 - Seine-et-Marne"},
        {value: "78", name: "78 - Yvelines"},
        {value: "79", name: "79 - Deux-Sèvres"},
        {value: "80", name: "80 - Somme"},
        {value: "81", name: "81 - Tarn"},
        {value: "82", name: "82 - Tarn-et-Garonne"},
        {value: "83", name: "83 - Var"},
        {value: "84", name: "84 - Vaucluse"},
        {value: "85", name: "85 - Vendée"},
        {value: "86", name: "86 - Vienne"},
        {value: "87", name: "87 - Haute-Vienne"},
        {value: "88", name: "88 - Vosges"},
        {value: "89", name: "89 - Yonne"},
        {value: "90", name: "90 - Territoire de Belfort"},
        {value: "91", name: "91 - Essonne"},
        {value: "92", name: "92 - Hauts-de-Seine"},
        {value: "93", name: "93 - Seine-Saint-Denis"},
        {value: "94", name: "94 - Val-de-Marne"},
        {value: "95", name: "95 - Val-d'oise"}
      ]
    }
  },
  input_text: {
    name: 'Aangepast veld',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      name: 'input_text',
      placeholder: '',
      type: 'text'
    }
  },
  car_km: {
    name: 'Kilometerstand voertuig',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Number',
      label: 'Kilometerstand voertuig',
      name: 'car_km',
      placeholder: '',
      type: 'text'
    }
  },
  company_name: {
    name: 'Bedrijfsnaam',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Bedrijfsnaam',
      name: 'company_name',
      placeholder: '',
      type: 'text'
    }
  },
  company_adress: {
    name: 'Adres',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Adres',
      name: 'company_adress',
      placeholder: '',
      type: 'text'
    }
  },
  company_email : {
    name: 'E-mail',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'E-mail',
      placeholder: '',
      validationRules: 'email',
      name: 'company_email',
      autocomplete: 'email',
      inputmode: 'email',
      type: 'email'
    }
  },
  company_zipcode: {
    name: 'Postcode',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Postcode',
      name: 'company_zipcode',
      placeholder: '',
      type: 'text'
    }
  },
  company_city: {
    name: 'Stad',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Stad',
      name: 'company_city',
      placeholder: '',
      type: 'text'
    }
  },
  company_phone: {
    name: 'Telefoonnummer',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'Telefoonnummer',
      placeholder: '',
      name: 'company_phone',
      validationRules: {
        required: true,
        phone: {
          phoneType: 'both',
          defaultCountry: 'NL',
          acceptedCountries: ['NL']
        }
      },
      autocomplete: 'tel',
      inputmode: 'tel',
      type: 'tel'
    }
  },
  ean: {
    name: 'EAN',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'EAN',
      placeholder: '',
      name: 'ean'
    }
  },
  bic: {
    name: 'BIC',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'Input',
      label: 'BIC',
      placeholder: '',
      name: 'bic'
    }
  },
  psa_reparateur: {
    name: 'Reparateur',
    type: 'string',
    mongo_type: String,
    form: {
      info: '',
      component: 'PSAReparateur',
      label: 'Reparateur',
      placeholder: '',
      name: 'Reparateur'
    }
  },
};

module.exports = rules;